export const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.386 19.9782H4.61395C2.06512 19.9782 0 17.9038 0 15.3549V8.46192C0 7.19677 0.781395 5.60608 1.78605 4.82468L6.8 0.917706C8.30698 -0.254384 10.7163 -0.310198 12.2791 0.787473L18.0279 4.81538C19.1349 5.58747 20 7.24329 20 8.59215V15.3642C20 17.9038 17.9349 19.9782 15.386 19.9782ZM7.65581 2.01538L2.64186 5.92236C1.9814 6.44329 1.39535 7.62468 1.39535 8.46192V15.3549C1.39535 17.1317 2.83721 18.5828 4.61395 18.5828H15.386C17.1628 18.5828 18.6047 17.141 18.6047 15.3642V8.59215C18.6047 7.6991 17.9628 6.46189 17.2279 5.95957L11.4791 1.93166C10.4186 1.18747 8.66977 1.22468 7.65581 2.01538Z"
        fill="#292D32"
      ></path>
      <path
        d="M9.99998 16.2572C9.61859 16.2572 9.30231 15.9409 9.30231 15.5595V12.7688C9.30231 12.3874 9.61859 12.0712 9.99998 12.0712C10.3814 12.0712 10.6977 12.3874 10.6977 12.7688V15.5595C10.6977 15.9409 10.3814 16.2572 9.99998 16.2572Z"
        fill="#292D32"
      ></path>
    </svg>
  );
};
